interface AnimatedSuccessCheckmarkProps {
	className?: string;
	size?: string;
	color?: string;
}

/**
 * An animated SVG checkmark icon used to indicate success.
 * Built entirely with Tailwind CSS utility classes and custom config extensions.
 */
export default function AnimatedSuccessCheckmark({ className = '', size = '3rem' }: AnimatedSuccessCheckmarkProps) {
	return (
		<div className={`flex justify-center items-center ${className}`} style={{ width: size, height: size }}>
			<svg
				className="w-full h-full rounded-full stroke-[3]"
				style={{
					stroke: 'var(--colour-brand-secondary)',
					strokeMiterlimit: 10,
				}}
				viewBox="0 0 52 52"
			>
				<circle
					className="animate-checkmark-circle"
					cx="26"
					cy="26"
					r="24"
					fill="none"
					style={{
						strokeDasharray: 166,
						strokeDashoffset: 166,
					}}
				/>
				<path
					className="origin-center animate-checkmark-check"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15 27l7 7 15-15"
					style={{
						strokeDasharray: 48,
						strokeDashoffset: 48,
					}}
				/>
			</svg>
		</div>
	);
}
